export default __webpack_public_path__ + "static/media/left.713fc2f5.svg";